import $ from 'jquery'
import _ from 'lodash'

export { default as fetch } from './fetch'

// Auth token encrypt and decrypt with room local storage data for offline support
export { default as SecureStorage } from './encrypt'

const code = [1,2,3,4,5,6,7,8] 
export const pinInput = (val) => {
  code.map(async(cd, ind) => {
      if (_.get(val, '['+ind+']', '') !== '') {
          $('.react-code-input').find('input:eq(' + ind + ')').val(val[ind])
      } 
      else if($('.react-code-input').find('input:eq(' + ind + ')').hasClass('inputSuccess')){
      	$('.react-code-input').find('input:eq(' + ind + ')').removeClass('inputSuccess')
      }
  })
}


// WEBPACK FOOTER //
// ./src/utils/index.js